import { render } from "./eb-list-item.vue?vue&type=template&id=22b48bfc"
import script from "./eb-list-item.vue?vue&type=script&lang=ts"
export * from "./eb-list-item.vue?vue&type=script&lang=ts"
script.render = render

export default script